import styled from "styled-components"
import { motion } from "framer-motion"

const AboutSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 20px;
  background-color: #f9f9f9;
`

const Title = styled(motion.h1)`
  color: red;
  text-align: center;
  margin-bottom: 40px;
`

const ContentWrapper = styled(motion.div)`
  display: flex;
  width: 100%;
  max-width: 1200px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`

const LeftColumn = styled(motion.div)`
  flex: 1;
  display: flex;
  justify-content: center;
  
  @media (max-width: 768px) {
    margin-bottom: 40px;
  }
`

const Image = styled(motion.img)`
  width: 70%;
  height: 440px;
  border-radius: 10px;
  transition: transform 0.3s ease-in-out;
  
  &:hover {
    transform: scale(1.05);
  }
`

const RightColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const Card = styled(motion.div)`
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }
`

const CardTitle = styled.h3`
  color: #d9534f;
  margin-bottom: 10px;
`

const CardText = styled.p`
  color: #555;
  line-height: 1.6;
`

const About = () => {
  return (
    <AboutSection
      as={motion.section}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
    id="about">
      <Title
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        About Our Church
      </Title>
      <ContentWrapper
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <LeftColumn>
          <Image
            src="/images/call.jpg"
            alt="About Our Church"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 1, delay: 0.3 }}
          />
        </LeftColumn>
        <RightColumn>
          <Card
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1, delay: 0.5 }}
            whileHover={{ scale: 1.02 }}
          >
            <CardTitle>Our Church</CardTitle>
            <CardText>
              Our church is a welcoming community focused on faith, love, and service. We aim to create a nurturing
              environment for spiritual growth and connection.
            </CardText>
          </Card>
          <Card
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1, delay: 0.7 }}
            whileHover={{ scale: 1.02 }}
          >
            <CardTitle>Our Vision</CardTitle>
            <CardText>
              We envision a strong faith-based community that supports individuals in their spiritual journey, fostering
              love, hope, and unity.
            </CardText>
          </Card>
        </RightColumn>
      </ContentWrapper>
    </AboutSection>
  )
}

export default About
